import { assertString } from '@Utils/assert';
import SocketBroker from '@Services/SocketBroker';
import { RxSocketUrls } from '@Constants/CommonConstants';

export function createFilter(params, history) {
  return ({ info: { query } }) =>
    (query.hitSetKey ? query.hitSetKey === params.hitSetKey : query.resultName === params.resultName && query.context === params.context) ||
    (history && history.location.state && history.location.state.context === query.context);
}

export function normalizeRelativeContextResponse(data) {
  Logger.info('Received response (getRelativeContexts): ', data);
  const { payload } = data;
  const { searches = [], hitSetKey } = payload;

  const normalizedRelativeContexts = searches.map(({ resultName, databaseId, context, resultSize, recordCount }) => ({
    id: context,
    context,
    hitSetKey,
    resultName,
    databaseId,
    resultSize,
    recordCount,
  }));

  return {
    hitSetKey,
    normalizedRelativeContexts,
  };
}

export function getRelativeContexts({ resultName, databaseId, context, hitSetKey }, history) {
  const params = { resultName, databaseId, context, hitSetKey };

  assertString(resultName, 'resultName');
  assertString(databaseId, 'databaseId');
  assertString(context, 'context');
  assertString(hitSetKey, 'hitSetKey');

  Logger.info('Send query (getRelativeContexts): ');
  return new Promise((resolve, reject) => {
    SocketBroker.send(
      {
        send: RxSocketUrls.SwitchContext,
        message: RxSocketUrls.ChannelsUrls.CoHitsets,
      },
      {
        params,
        oneTime: true,
        filter: createFilter(params, history),
      }
    ).subscribe({
      next: ({ data }) => resolve(data),
      error: reject,
    });
  })
    .then(normalizeRelativeContextResponse)
    .catch(Logger.reject);
}
